"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _forms = require("../utils/forms");

var _formik = require("formik");

var _useDebugLogger = _interopRequireDefault(require("../hooks/useDebugLogger"));

/**
 * This is a warning message if a custom onChange or onBlur handler
 * is used.
 */
var overWriteFuncMessage = function overWriteFuncMessage(fieldName, funcType) {
  return "Olympic-lib: ".concat(fieldName, " ").concat(funcType, "\n\nYou are using custom function and input values are not being set to Formik state.\n\nTo use Formik state with a custom function use the \"setValue\" function in the third argument (helpers) passed to your custom function.\n\nIf you want to simply transform the \"transformTargetValue\" function in @earnup/olympic-lib/utils/events.\n\nNB: the entire formik context comes as the forth argument to your custom function.\n");
};
/**
 * Get handlers for form field state.
 *
 * @param {Function} props.onBlur onBlur
 * @param {Function} props.onChange onChange
 * @param {String|Number} props.value value
 * @param {String} props.error error
 * @param {String} props.helperText helperText
 * @param {Boolean} props.checked checked
 * @param {String} props.name name
 * @param {Boolean} props.debug name
 * @param {Boolean} props.withoutState withoutState explicity don't use Formik state
 */


var useFormState = function useFormState(_ref) {
  var onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      value = _ref.value,
      error = _ref.error,
      helperText = _ref.helperText,
      checked = _ref.checked,
      name = _ref.name,
      debug = _ref.debug,
      _ref$withoutState = _ref.withoutState,
      withoutState = _ref$withoutState === void 0 ? false : _ref$withoutState;
  var isState = (0, _forms.isStateContext)() && !withoutState && name;

  if (!isState) {
    return {
      onBlur: onBlur,
      onChange: onChange,
      value: value,
      error: error,
      helperText: helperText,
      checked: checked,
      name: name,
      helpers: null
    };
  }

  var logger = (0, _useDebugLogger["default"])(debug);

  var _useField = (0, _formik.useField)({
    name: name
  }),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helpers = _useField2[2];

  var context = (0, _formik.useFormikContext)(); // If onBlur or onChange is passed by the component,
  // pass context and helpers to the callback.
  // context is the whole formik context
  // helpers are the helper function for the specific
  // component getFormHandlers is called in.
  // props will generally just be the event

  var onBlurContext = function onBlurContext(event, value) {
    logger.warn(overWriteFuncMessage(name, 'onBlur'));
    logger.info('event: ', event);
    logger.info('value: ', value);
    logger.info('helpers: ', helpers);
    logger.info('context: ', context);
    onBlur(event, value, helpers, context);
  };

  var onChangeContext = function onChangeContext(event, value) {
    logger.warn(overWriteFuncMessage(name, 'onChange'));
    logger.info('event: ', event);
    logger.info('value: ', value);
    logger.info('helpers: ', helpers);
    logger.info('context: ', context);
    onChange(event, value, helpers, context);
  };

  var getTruthyValue = function getTruthyValue(value) {
    return (0, _forms.isTruthyOrZero)(value) ? value : null;
  };

  var formikError = (0, _forms.getError)(context, name);
  var formikValue = (0, _forms.getValue)(field, name);
  var formikHelperText = (0, _forms.getHelperText)(context, name);
  var inputValues = {
    onBlur: onBlur && onBlurContext,
    onChange: onChange && onChangeContext
  };
  var returnFormValues = {
    name: name,
    error: error || formikError,
    helperText: formikHelperText || helperText,
    value: getTruthyValue(value || formikValue),
    checked: checked || field.checked,
    onBlur: inputValues.onBlur || field.onBlur,
    onChange: inputValues.onChange || field.onChange,
    helpers: helpers
  };
  logger.group("".concat(name, " field values"));
  logger.info('Returned form state: ', returnFormValues);
  logger.info('helpers: ', helpers);
  logger.info('context: ', context);
  logger.groupEnd();
  return returnFormValues;
};

var _default = useFormState;
exports["default"] = _default;